module.exports = __webpack_public_path__ + "static/media/create_ad.d20059e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/create_ad.png
// module id = 1476
// module chunks = 1